// Example month of the tutorial video. Made-up projects and patients; the
// layout is fixed (5 week rows × 7 columns) so the story reads the same in
// every month and language.

export const PROJECTS = {
  onko: { name: 'ONKO-301', slot: 1 },
  kardiyo: { name: 'KARDİYO-12', slot: 2 },
  noro: { name: 'NÖRO-7', slot: 3 },
};

// row/col: week row and weekday column; mark: visit day; done: day it was done
export const VISITS = [
  { id: 'A', row: 0, start: 1, end: 4, mark: 2, done: 3, lane: 0, state: 'completed', project: 'onko', patient: 'P-1042', number: 2 },
  { id: 'B', row: 0, start: 3, end: 6, mark: 4, lane: 1, state: 'overdue', project: 'kardiyo', patient: 'P-0931', number: 1 },
  { id: 'C', row: 1, start: 2, end: 6, mark: 4, lane: 0, state: 'inProgress', project: 'kardiyo', patient: 'P-0877', number: 5 },
  { id: 'G', row: 1, start: 3, end: 5, mark: 5, lane: 1, state: 'inProgress', project: 'onko', patient: 'P-1088', number: 2 },
  { id: 'N', row: 2, start: 0, end: 6, mark: 3, lane: 1, state: 'planned', project: 'onko', patient: 'P-1120', number: 4, isNew: true },
  { id: 'D', row: 2, start: 3, end: 6, mark: 4, lane: 0, state: 'planned', project: 'onko', patient: 'P-1042', number: 3 },
  { id: 'E', row: 3, start: 1, end: 5, mark: 3, lane: 0, state: 'planned', project: 'kardiyo', patient: 'P-0877', number: 6 },
  { id: 'F', row: 4, start: 2, end: 4, mark: 3, lane: 0, state: 'planned', project: 'noro', patient: 'P-1150', number: 1 },
];

// J3 is the job added in the video, linked to a project (hidden until saved)
export const JOBS = [
  { id: 'J1', kind: 'job', row: 1, start: 0, end: 1, lane: 0, titleKey: 'jobDocs', done: true },
  { id: 'J2', kind: 'job', row: 3, start: 6, end: 6, lane: 0, titleKey: 'jobTraining', done: false },
  { id: 'J3', kind: 'job', row: 4, start: 0, end: 1, lane: 0, titleKey: 'jobSupplies', done: false, project: 'onko', isNew: true },
];

// Projects the example employee is actively assigned to (NÖRO-7 is passive)
export const ACTIVE_PROJECT_KEYS = ['onko', 'kardiyo'];

export const TODAY = { row: 1, col: 3 };
export const CLICKED_DAY = { row: 1, col: 4 };

export const visitById = (id) => VISITS.find((visit) => visit.id === id);

export const jobById = (id) => JOBS.find((job) => job.id === id);

/** The jobs on screen for a story state (the new one hidden until saved). */
export const sceneJobs = ({ newJob = false }) => JOBS.filter((job) => !job.isNew || newJob);

/** Visits and jobs planned on a day, and the visits whose window is open on it. */
export const dayLists = (day, visits, jobs = JOBS) => {
  const inRow = visits.filter((visit) => visit.row === day.row && visit.start <= day.col && visit.end >= day.col);
  return {
    planned: inRow.filter((visit) => visit.mark === day.col),
    windows: inRow.filter((visit) => visit.mark !== day.col),
    jobs: jobs.filter((job) => job.row === day.row && job.start <= day.col && job.end >= day.col),
  };
};

/**
 * 35 consecutive days from the Monday of the week holding the 1st of `base`'s
 * month, so every cell of the 5 rows has a date (days of the neighbouring
 * months are drawn faded).
 */
export const monthDays = (base) => {
  const year = base.getFullYear();
  const month = base.getMonth();
  const offset = (new Date(year, month, 1).getDay() + 6) % 7;
  return Array.from({ length: 35 }, (_, index) => {
    const date = new Date(year, month, 1 - offset + index);
    return { date, inMonth: date.getMonth() === month };
  });
};

export const dateOfCell = (base, row, col) => monthDays(base)[row * 7 + col].date;
